import axios from 'axios';
import type { ProfasePeriodoActividadData } from './profase-periodo-actividad';

/** DTO de GET/PUT asignación workflow ↔ periodo actividad. Ver doc/ProfaseWorkflowPeriodo.MD */
export interface PeriodoActividadWorkflowPeriodo {
  id: number;
  nombre?: string | null;
  tipoPeriodo?: string | null;
  numeroPeriodo?: number | null;
  data?: ProfasePeriodoActividadData | null;
  habilitado: boolean;
  asignado: boolean;
  workflowPeriodoId?: number | null;
  vigente?: boolean | null;
  vigenteDesde?: string | null;
  vigenteHasta?: string | null;
}

export interface SyncPeriodoActividadWorkflowRequest {
  periodoActividadIds: number[];
}

export const WORKFLOW_PERIODO_API = 'api/profase-workflow-periodos';

export function workflowPeriodoActividadesUrl(workflowId: number): string {
  return `${WORKFLOW_PERIODO_API}/por-workflow/${workflowId}/periodo-actividades`;
}

/** Ids de catálogo ProfasePeriodoActividad asignados y vigentes al workflow. */
export async function fetchAssignedPeriodoActividadIds(
  workflowId: number,
): Promise<number[]> {
  const res = await axios.get<PeriodoActividadWorkflowPeriodo[]>(
    workflowPeriodoActividadesUrl(workflowId),
    { params: { asignado: true } },
  );
  return (Array.isArray(res.data) ? res.data : [])
    .filter(item => item.asignado)
    .map(item => item.id);
}
